import Title from 'app/ui/display/Title';
import ScoreDisplay from 'app/ui/display/ScoreDisplay';
import HighScoreDisplay from 'app/ui/display/HighScoreDisplay';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import * as AppConstants from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';

export default class HudGameIntro extends Phaser.Group {
  constructor({ game, message, onClose = false, onCloseScope = false }) {
    super(game);

    this.background = new BackgroundColourFill({ game, colour: '#000000', alpha: 0.3 });
    this.background.width = this.game.width;
    this.background.height = this.game.height;
    this.add(this.background);

    // container to house and position contents
    this.container = this.game.make.group();
    this.add(this.container);

    // baking panel
    this.panel = this.game.make.image(0, 0, 'ui', 'panel_generic');
    this.container.add(this.panel);

    // continue button
    this.btnContinue = new ButtonSimple({ game: this.game, id: 'btn_play', skin: 'btn_play', defaultScale: 0.7 });
    this.btnContinue.x = this.panel.width * 0.5;
    this.btnContinue.y = this.panel.y + this.panel.height * 0.4;
    this.btnContinue.scale.set(0.7);
    this.btnContinue.onInputDown.add(this.handleContinue, this);
    this.container.addChild(this.btnContinue);

    // restart button
    this.btnRestart = new ButtonSimple({ game: this.game, id: 'btn_replay', skin: 'btn_replay', defaultScale: 0.7 });
    this.btnRestart.y = this.panel.y + this.panel.height * 0.65;
    this.btnRestart.x = this.panel.width * 0.5;
    this.btnRestart.scale.set(0.7);
    this.btnRestart.onInputDown.add(this.handleRestart, this);
    this.container.addChild(this.btnRestart);

    //copy
    this.mainCopy = createTextField(this.game, AppConstants.FONT_TITLE, 62, AppConstants.FONT_COLOUR_PAUSED, 0, 0, {
      wordWrap: true,
      wordWrapWidth: this.panel.width * 0.9,
      align: 'center',
    });
    this.mainCopy.text = this.game.copy.getCopy('pause');
    this.mainCopy.anchor.set(0.5);
    this.mainCopy.position.set(this.panel.x + this.panel.width * 0.5, this.panel.y + this.panel.height * 0.1);
    this.container.addChild(this.mainCopy);

    this.onion = this.game.make.image(0, 0, 'ui', 'onion_pause');
    this.onion.anchor.set(0, 1);
    this.onion.scale.set(1);
    this.onion.position.set(this.panel.x + this.onion.width * 0.4, this.panel.y + this.panel.height * 0.74);
    this.container.addChild(this.onion);

    this.apple = this.game.make.image(0, 0, 'ui', 'apple_pause');
    this.apple.anchor.set(1, 1);
    this.apple.scale.set(1);
    this.apple.position.set(this.panel.x + this.panel.width - this.apple.width * 0.15, this.panel.y + this.panel.height * 0.7);
    this.container.addChild(this.apple);

    // and we adjust the height of the panel to suit
    this.panel.height = this.btnRestart.y + this.btnRestart.height;

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    this.handleScreenResize();
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get height() {
    return this.panel.height + this.panel.y;
  }

  get width() {
    return this.panel.width;
  }

  /*
  ============================================================================================
    EVENT HANDLERS
  ============================================================================================
  */

  handleScreenResize() {
    this.container.x = this.game.width * 0.5 - this.width * 0.5;
    this.container.y = this.game.height * 0.5 - this.height * 0.5;

    this.background.width = this.game.width;
    this.background.height = this.game.height;
  }

  handleCredits() {
    this.game.controller.showGameCredits();
  }

  handleRestart() {
    this.game.controller.restartLevel();
  }

  handleContinue() {
    this.game.controller.resumeGame();
  }

  /*
  ============================================================================================
    TOODLES!
  ============================================================================================
  */

  destroy() {
    // clear listeners
    this.game.scale.onSizeChange.remove(this.handleScreenResize, this);
    this.btnContinue.onInputDown.remove(this.handleContinue, this);
    this.btnRestart.onInputDown.remove(this.handleContinue, this);

    // destroy stuff
    this.btnRestart.destroy(true);
    this.btnContinue.destroy(true);
    this.panel.destroy(true);
    this.container.destroy(true);

    // nullify
    this.btnContinue = null;
    this.btnRestart = null;
    this.panel = null;
    this.container = null;

    // super dupa
    super.destroy(true);
  }
}
